/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Pagination, Spin, Table, Tag, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { _get_wise9ja_month } from "common/axios_services";
import { NumericFormat } from "react-number-format";
import { useParams } from "react-router-dom";

function Wise9jaTransMonthly() {
    const params = useParams()
    const [page, setPage] = useState(1);
    const [total_categories, setTotal_categories] = useState(0);
    const [page_size, setPage_size] = useState(10);
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [wise9ja, setWise9ja] = useState([]);
    const [searchInfo, setSearchInfo] = useState('');

    const jwt = localStorage.konnect_admin_token;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };


    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }

    const getWise9jaMonth = async () => {
        try {
            const fetchAllWise9ja = await _get_wise9ja_month({ page, page_size, search: searchInfo, month: params.id })
            setSpinnerLoading(false)
            setWise9ja(fetchAllWise9ja.data.data);
            setTotal_categories(fetchAllWise9ja.data.meta.total)
        } catch (err) {
            setSpinnerLoading(false)
            if (err.response) {
                if (err.response === "Unauthorized") {
                    window.location.reload()
                    openNotificationWithIcon('error', err.response.data.message);
                } else {
                    openNotificationWithIcon('error', err.response.data.message);
                }
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }
    useEffect(() => {
        getWise9jaMonth()
    }, [page, page_size])

    // Functions to handle
    const change_page = (selected_page, pageSize) => {
        setPage(selected_page);
        setPage_size(pageSize);
    }

    let data = wise9ja.map((trans, index) => {
        return {
            key: index,
            date: trans.created_at.split('T')[0],
            name: <span className="d-flex flex-column"><span style={{ textTransform: "capitalize" }}>{trans.user.first_name + ' ' + trans.user.last_name}</span><p style={{ color: "#6e7a75" }}>{trans.user.email}</p></span>,
            ref: trans.referense_no,
            amount: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans.amount) * 1)} />,
            duration: trans.month_duration,
            monthlyCash: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans.monthly_commission) * 1)} />,
            voucher: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans.voucher_bonus) * 1)} />,
            status: <div style={{ textTransform: "capitalize" }}>{trans.status === "success" ? <Tag color="green">{trans.status}</Tag> : trans.status === "cancel" ? <Tag color="red">{trans.status}</Tag> : <Tag color="orange">{trans.status}</Tag>}</div>,
        }
    });
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
        },
        {
            title: 'Duration (month)',
            className: 'column-number',
            dataIndex: 'duration',
            align: 'center',
        },
        {
            title: 'Name',
            className: 'column-number',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: 'Reference',
            dataIndex: 'ref',
        },
        {
            title: 'Amount (NGN)',
            className: 'column-number',
            dataIndex: 'amount',
            align: 'right',
        },
        {
            title: 'Purchase Voucher (NGN)',
            className: 'column-number',
            dataIndex: 'voucher',
            align: 'right',
        },
        {
            title: 'Monthly Cash (NGN)',
            className: 'column-number',
            dataIndex: 'monthlyCash',
            align: 'right',
        },
        {
            title: 'Payment Status',
            className: 'column-number',
            dataIndex: 'status',
            align: 'center',
        }
    ];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    Shop {params.id} Report
                                </MDTypography>
                            </MDBox>
                            <MDBox py={3} px={2}>
                                <Spin tip="Loading..." spinning={spinnerLoading}>
                                    <React.Fragment>
                                        <>
                                            <div className="table-responsive">
                                                <Table columns={columns} pagination={false} dataSource={data} bordered />
                                                <div style={{ marginTop: "2%" }}></div>
                                                <Pagination showSizeChanger current={page} total={total_categories} showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} transactions`} defaultPageSize={page_size} onChange={change_page} />
                                            </div>
                                        </>
                                    </React.Fragment>
                                </Spin>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );

};

export default Wise9jaTransMonthly;
